import { message } from 'antd';

const showMessage = (type, content) => {
  switch (type) {
    case 'success':
      message.success(content);
      break;
    case 'error':
      message.error(content);
      break;
    default:
      message.info(content);
  }
};

const setting = { showMessage };
export { showMessage };
export default setting;